import React, { FC, useState } from 'react';
import Skeleton from '@mui/material/Skeleton';

interface Props {
  src: string;
  fileName: string;
  width: string;
  type: string;
}

export const AssetWithPlaceholder: FC<Props> = ({ src, width, fileName }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  return (
    <>
      {isLoading && !hasError && (
        <Skeleton animation="wave" width={140} height={78} />
      )}
      {hasError ? (
        <div
          style={{
            width,
            height: 78,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 6,
            background: '#f1f5f9',
            color: '#64748b',
            fontSize: 12,
          }}
        >
          Thumbnail unavailable
        </div>
      ) : (
        <img
          src={src}
          hidden={isLoading}
          width={width}
          height={78}
          onLoad={() => setIsLoading(false)}
          onError={() => {
            setIsLoading(false);
            setHasError(true);
          }}
          alt={`${fileName} thumbnail`}
          style={{ objectFit: 'cover', borderRadius: 6 }}
        />
      )}
    </>
  );
};
